module.exports = __webpack_public_path__ + "img/trademark.705f6dab.svg";